import { render, staticRenderFns } from "./FooterComponentBrick.vue?vue&type=template&id=94e3a5be&scoped=true&"
import script from "./FooterComponentBrick.vue?vue&type=script&lang=js&"
export * from "./FooterComponentBrick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e3a5be",
  null
  
)

export default component.exports